import tableComponent from "./table.vue";
import detailsComponent from "./details.vue";
import actionsComponent from "./actions.vue";

export default {
  table: tableComponent,
  details: detailsComponent,
  actions: actionsComponent,
};
